import CryptoJS from "crypto-js";

export function encryption(email) {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_K);
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV);
  const encrypted = CryptoJS.AES.encrypt(email, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  });
  return encrypted.toString();
}

export function decryption(encryptedData) {
  if (!encryptedData) {
    return null;
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_K);
    const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV);

    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);

    return decryptedData;
  } catch (error) {
    return null;
  }
}

// Known app prefixes that are NOT tenant subdomains
export const APP_PREFIXES = ["ack", "training", "vendor", "tprm"];

export const subdomain = (() => {
  const STORAGE_KEY = "portal-tenant";

  // Check for tenant in URL query params
  const tenantParam = new URLSearchParams(window.location.search).get("tenant");
  if (tenantParam) {
    localStorage.setItem(STORAGE_KEY, tenantParam);
    return tenantParam;
  }

  // Fallback to localStorage
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) return saved;

  return "default";
})();

/**
 * Returns the backend API base URL.
 * - localhost: Uses REACT_APP_BACKEND from .env (e.g. "http://localhost:8000/api/")
 * - dev/stage/prod: Returns "/api/" (absolute root URL) so nested routes don't inherit relative paths
 */
export const getBackendUrl = () => {
  const envBackend = process.env.REACT_APP_BACKEND;
  if (window.location.hostname === "localhost") {
    return (envBackend || "http://localhost:8000/api/").replace(/\/$/, '') + '/';
  }
  if (envBackend) return envBackend.replace(/\/$/, '') + '/';
  return "/api/"; 
};

export const buildTenantApiUrl = (endpoint, lang = 'en') => {
  const backend = getBackendUrl();
  const sub = subdomain;
  // endpoint might contain leading slashes, we strip them to avoid double slashes 
  const cleanEndpoint = endpoint.replace(/^\/+/, '');
  // Format: http://localhost:8000/api/tenant/en/tprm/...
  return `${backend}${sub}/${lang}/${cleanEndpoint}`;
};
